/**
 * 模块说明：销售折扣
 */
import { Service } from '@/tools'
export class DiscountServer<T extends TOrder.Discount> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Discount}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  private postUpload<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Discount}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }

  /**
   * 功能：销售折扣-列表-分页
   * /api/order/discount/v1/pageDiscount
   */
  pageDiscount = <K extends T['ApiPageDiscount']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPageDiscount', data)
  /**
   * 功能：销售折扣明细-列表-分页
   * /api/order/discount/v1/pageDiscountDetail
   */
  pageDiscountDetail = <K extends T['ApiPageDiscountDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPageDiscountDetail', data)
  /**
   * 功能：销售折扣-新增
   * /api/order/discount/v1/insertDiscount
   */
  insertDiscount = <K extends T['ApiInsertDiscount']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiInsertDiscount', data)
  /**
   * 功能：销售折扣-保存
   * /api/order/discount/v1/saveDiscount
   */
  saveDiscount = <K extends T['ApiSaveDiscount']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiSaveDiscount', data)
  /**
   * 功能：销售折扣-编辑
   * /api/order/discount/v1/editDiscount
   */
  editDiscount = <K extends T['ApiEditDiscount']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiEditDiscount', data)
  /**
   * 功能：销售折扣-查看
   * /api/order/discount/v1/queryDiscountDetail
   */
  queryDiscountDetail = <K extends T['ApiQueryDiscountDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryDiscountDetail', data)
  /**
   * 功能：销售折扣-启用
   * /api/order/discount/v1/enableDiscount
   */
  enableDiscount = <K extends T['ApiEnableDiscount']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiEnableDiscount', data)
  /**
   * 功能：销售折扣-禁用
   * /api/order/discount/v1/disableDiscount
   */
  disableDiscount = <K extends T['ApiDisableDiscount']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiDisableDiscount', data)
  /**
   * 功能：销售折扣-复制
   * /api/order/discount/v1/copyDiscount
   */
  copyDiscount = <K extends T['ApiCopyDiscount']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiCopyDiscount', data)
  /**
   * 功能：销售折扣-关闭
   * /api/order/discount/v1/closeDiscount
   */
  closeDiscount = <K extends T['ApiCloseDiscount']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiCloseDiscount', data)
  /**
   * 功能：查询销售折扣对外接口
   * /api/order/discount/v1/queryDiscount
   */
  queryDiscount = <K extends T['ApiQueryDiscount']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryDiscount', data)
  /**
   * 销售折扣历史版本
   * /api/order/price/v1/queryDiscountVersionList
   */
  queryDiscountVersionList = <K extends T['ApiQueryDiscountVersionList']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryDiscountVersionList', data)
  /**
   * 销售折扣历史版本详情
   * /api/order/price/v1/queryDiscountVersionDetail
   */
  queryDiscountVersionDetail = <K extends T['ApiQueryDiscountVersionDetail']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryDiscountVersionDetail', data)
  /**
   * 功能：销售折扣导入商品
   */
  discountCommodityImport = (data: T['ApiDiscountCommodityImport']['req']): Promise<T['ApiDiscountCommodityImport']['res']> =>
    this.postUpload('v1/ApiDiscountCommodityImport', data)
  /**
   * 功能：销售折扣下载导入模板
   */
  discountCommodityDownloadReport = (): Promise<T['ApiDiscountCommodityDownloadReport']['res']> =>
    this.post2('v1/ApiDiscountCommodityDownloadReport', undefined, 'blob')
}
